/*
  パスワード強度チェッカー

  = javascript_pack_tag 'password-strength-checker'

  = f.password_field :password, class: 'form-control',
    data: { password_strength_check: api_password_strength_url },
    placeholder: User.human_attribute_name(:password)
*/

document.addEventListener('DOMContentLoaded', function () {
  const passwordInputs = document.querySelectorAll('[data-password-strength-check]');

  passwordInputs.forEach((passwordInput) => {
    // 新しいdiv要素を作成
    const wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.width = '100%';

    // 新しいspan要素を作成
    const passwordStrengthDisplay = document.createElement('span');
    passwordStrengthDisplay.classList.add('password-strength');

    // スタイルを設定
    passwordStrengthDisplay.style.position = 'absolute';
    passwordStrengthDisplay.style.right = '10px';
    passwordStrengthDisplay.style.top = '50%';
    passwordStrengthDisplay.style.transform = 'translateY(-50%)';
    passwordStrengthDisplay.style.maxWidth = 'calc(100% - 20px)';
    passwordStrengthDisplay.style.overflow = 'hidden';
    passwordStrengthDisplay.style.textOverflow = 'ellipsis';

    // 違反メッセージ表示用の要素を作成
    const violationsDisplay = document.createElement('div');
    violationsDisplay.classList.add('password-violations');
    violationsDisplay.style.fontSize = '12px';
    violationsDisplay.style.color = 'red';
    violationsDisplay.style.marginTop = '4px';

    // パスワード入力欄をwrapperに移動
    passwordInput.parentNode.insertBefore(wrapper, passwordInput);
    wrapper.appendChild(passwordInput);

    // パスワード入力欄の後ろに追加
    wrapper.appendChild(passwordStrengthDisplay);

    // wrapper の後ろに違反メッセージを追加
    wrapper.parentNode.insertBefore(violationsDisplay, wrapper.nextSibling);

    // フォーム内のemail/sign_idフィールドを検出
    const form = passwordInput.closest('form');

    let timeoutId;
    passwordInput.addEventListener('input', function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const password = this.value;
        const endpoint = this.dataset.passwordStrengthCheck;

        // リクエストボディにemail/sign_idを含める（ID含有チェック用）
        const body = { password: password };
        if (form) {
          const emailInput = form.querySelector('input[name*="[email]"], input[type="email"]');
          const signIdInput = form.querySelector('input[name*="[sign_id]"]');
          if (emailInput) body.email = emailInput.value;
          if (signIdInput) body.sign_id = signIdInput.value;
        }

        const csrfMeta = document.querySelector('meta[name="csrf-token"]');
        const headers = { 'Content-Type': 'application/json' };
        if (csrfMeta) headers['X-CSRF-Token'] = csrfMeta.content;

        fetch(endpoint, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(body)
        })
          .then((response) => response.json())
          .then((data) => {
            const hasViolations = data.violations && data.violations.length > 0;

            // パスワードの強度を表示
            passwordStrengthDisplay.textContent = data.strength;

            // スコアに応じて文字色を変更（違反がある場合は常に赤色）
            if (hasViolations || data.score <= 1) {
              passwordStrengthDisplay.style.color = 'red';
            } else if (data.score <= 2) {
              passwordStrengthDisplay.style.color = 'orange';
            } else {
              passwordStrengthDisplay.style.color = 'green';
            }

            // 違反メッセージの表示
            if (hasViolations) {
              violationsDisplay.textContent = data.violations.join(' / ');
            } else {
              violationsDisplay.textContent = '';
            }
          })
          .catch(() => {
            passwordStrengthDisplay.textContent = '';
            violationsDisplay.textContent = '';
          });
      }, 500);
    });
  });
});
